export const hasErrors = (errorObject?: object) => !!errorObject && Object.keys(errorObject).length > 0;
